import { createElementBlock as o, openBlock as t, createElementVNode as r } from "vue";
const l = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function n(L, e) {
  return t(), o("svg", l, e[0] || (e[0] = [
    r("path", {
      d: "M18,9.05500206 C18,4.05405883 13.9705664,0 9,0 C4.02943359,0 0,4.05405883 0,9.05500206 C0,13.5746153 3.29116992,17.320698 7.59375,18 L7.59375,11.6724636 L5.30859375,11.6724636 L5.30859375,9.05500206 L7.59375,9.05500206 L7.59375,7.06007192 C7.59375,4.79066203 8.93738672,3.53711018 10.9931836,3.53711018 C11.9778574,3.53711018 13.0078125,3.71396569 13.0078125,3.71396569 L13.0078125,5.9423451 L11.8729336,5.9423451 C10.7549121,5.9423451 10.40625,6.64034074 10.40625,7.3564287 L10.40625,9.05500206 L12.9023438,9.05500206 L12.5033203,11.6724636 L10.40625,11.6724636 L10.40625,18 C14.7088301,17.320698 18,13.5746153 18,9.05500206",
      transform: "translate(3 3)",
      fill: "#1877F2",
      "fill-rule": "evenodd"
    }, null, -1)
  ]));
}
const a = { render: n };
export {
  a as default,
  n as render
};
